import { render, staticRenderFns } from "./InterfaceMultipleCheckbox.vue?vue&type=template&id=4806d705"
import script from "./InterfaceMultipleCheckbox.vue?vue&type=script&lang=js"
export * from "./InterfaceMultipleCheckbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports